import { STOCK_MOVEMENT_REASONS } from './poz-stock-movement';

export class PmConfig{
    
    allowMultipleProductByBarcode? : boolean;
    stepQuantities? : string[];
    showBoxQuantityToSteps? : boolean;
    
    filterByBrand? : boolean;
    filterByCategory? : boolean;
    filterByLocation? : boolean;

    showProductImages? : boolean;

    /** Prefix of the stock count session references, e.g. `CNT/{year}/`. */
    prefixStockCount? : string;
    /** Hides the theoretical quantity on new count sessions by default. */
    blindCountByDefault? : boolean;
    /**
     * Reasons offered for a manual stock correction, in order — the first one
     * is preselected. Built-in codes are translated, anything else is shown as typed.
     */
    stockMovementReasons? : string[];

    constructor(){
        this.allowMultipleProductByBarcode = false;
        this.stepQuantities = ['1','10'];
        this.showBoxQuantityToSteps = true;
        this.filterByCategory = true;
        this.showProductImages = true;
        this.prefixStockCount = 'CNT/{year}/';
        this.blindCountByDefault = false;
        this.stockMovementReasons = [...STOCK_MOVEMENT_REASONS];
    }
}
